<!-- <p>historical-reports works!</p> -->
<div class="main-div">
	<div class="title alignRow" style="display: flex;">
		<span>Report History</span>
		<span class="toolbar-spacer"></span>
		<button mat-raised-button (click)="backClicked()" style="margin: 0.25em; margin-bottom: 0.5em;" class="app-icon--back">
			<mat-icon/>
			<span>Back</span>
		</button>
	</div>
	<mat-form-field>
		<mat-label>Search by Report Name, Description, File Type, or Date Generated</mat-label>
		<input matInput placeholder="" #input (keyup)="onFilteringReportHistory($event)">
	</mat-form-field>
	<div class="report-item title">
		<span>Name</span>
		<span>Description</span>
		<span>File Type</span>
		<span>GeneratedAt</span>
	</div>
	<div class="list-container">
		<ejs-listbox [dataSource]='filteredHistoricalReports' [fields]="fields">
			<ng-template #itemTemplate let-data>
				<div class="report-item ejs-listbox-item alignRow">
					<span>{{data.Name}}</span>
					<span>{{data.Description}}</span>
					<span>{{data.FileType}}</span>
					<span>{{convertEpoch(data.GeneratedAt)}}</span>
					<span class="file-link" (click)="getFile(data)">{{data.FileName}}</span>
					<button mat-icon-button (click)="getFile(data, true)">
						<mat-icon>download</mat-icon>
					</button>
				</div>
			</ng-template>
		</ejs-listbox>
	</div>
</div>